import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../Image';
import Section from './Section';


export default function PageTitle(props) {
    const {
        background, menu, group, title, children, className, black,
    } = props;

    const content = (
        <>
            {group && <h3 className={classNames(black ? '!text-certego-white' : '!text-certego-black')}>{group}</h3>}
            {title && <h1 className={classNames('font-bold', black ? '!text-certego-white' : '!text-certego-blue')}>{title}</h1>}
            {children && <div className="pt-6">{children}</div>}
        </>
    );

    return (
        <Section
            head={menu || group || true}
            color={black ? 'black' : 'lightgray'}
            className={classNames(background && 'aspect-[2.8] max-md:mb-[100px] !bg-certego-white', className)}
            background={background && (
                <div className="relative w-full h-full">
                    <Image img={background} className="w-full object-cover" />
                    <div className="absolute top-[90%] md:top-[24%] left-[3%]">
                        {content}
                    </div>
                </div>
            )}
        >
            {!background && (
            <div className={classNames('py-20', className)}>
                {content}
            </div>
            )}
        </Section>
    );
}

PageTitle.defaultProps = {
    background: undefined,
    black: false,
    children: null,
    className: null,
    group: null,
    menu: null,
    title: null,
};

PageTitle.propTypes = {
    background: PropTypes.string,
    black: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    group: PropTypes.node,
    menu: PropTypes.node,
    title: PropTypes.node,
};
